import React, {Component} from "react";
import UsageHorizontalChart from "../chart/horizontal-chart.component";


class BreakdownUsageTrend extends Component {
    render() {       
        return (
           <div className="usage-spend-wrapper">
                <UsageHorizontalChart printData={this.props.printData} setRef={this.props.setRef} resetData={this.props.resetData} dateCurrentMonth={this.props.dateCurrentMonth} data={this.props.data}/>
           </div>
        )
    }
}

export default BreakdownUsageTrend
